import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ContactPage from "@/pages/ContactPage";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { Cases } from "@/components/site/Cases";
import { Stack } from "@/components/site/Stack";
import { Faq } from "@/components/site/Faq";
import { Contact, Footer } from "@/components/site/Contact";

let lenis;

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) lenis?.scrollTo(el, { offset: -90, immediate: true });
      }, 50);
      return () => clearTimeout(t);
    }
    lenis?.scrollTo(0, { immediate: true });
    return undefined;
  }, [pathname, hash]);
  return null;
};

const Home = () => (
  <>
    <Nav />
    <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <Cases />
        <Stack />
        <Faq />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    lenis = new Lenis({ duration: 1.2, anchors: { offset: -90 } });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div className="grain min-h-screen overflow-x-clip bg-[#FBF9F5] font-sans text-ink">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
